<gabarit-global [configuration]="configNavigation">
  <app-spinner></app-spinner>
  <main id="changement-coordonnee">
    <div [hidden]="isLoading">
      <dsd-grid [class]="isApp ? 'dsd-m-md' : 'dsd-mt-md'">
        <router-outlet></router-outlet>
      </dsd-grid>
    </div>
    <app-modale-annuler></app-modale-annuler>
  </main>
</gabarit-global>
